const FRACTION_DIGITS = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

export default FRACTION_DIGITS;